// Update the import
import { useUserSettingsStore } from '@frontend/client/contexts/useUserSettingsStore';
import { Text, TextProps } from '@radix-ui/themes';

const PrivacyText = ({
  children,
  size = '2',
  ...props
}: { children: React.ReactNode } & TextProps) => {
  const { preferredPrivacy } = useUserSettingsStore();

  // Map Radix text sizes to appropriate blur values
  const blurSizes: Record<string, string> = {
    '1': 'blur-[3px]',
    '2': 'blur-[3px]',
    '3': 'blur-[4px]',
    '4': 'blur-[5px]',
    '5': 'blur-[6px]',
    '6': 'blur-[7px]',
    '7': 'blur-[8px]',
    '8': 'blur-[9px]',
    '9': 'blur-[10px]',
  };

  return (
    <Text
      size={size}
      {...props}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={`transition-all duration-200 ${
        preferredPrivacy === 'private'
          ? `${blurSizes[size as string]} hover:blur-none`
          : ''
      }`}
    >
      {children}
    </Text>
  );
};

export default PrivacyText;
